<div [hidden]="isLoading|| grid?.data?.length === 0" 
  [hidden]="isLoading|| !parent.exibirGrid || grid?.data?.length === 0" style="min-height:300px">
  <div class="table-responsive">
    <table id="relatorios" mat-table [dataSource]="grid" class="table-sm">

      <ng-container matColumnDef="action" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let grid" width="90px">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">

            <!-- <button mat-menu-item color="primary" [disabled]="!parent.habilitarAnulacao && true" (click)="parent.acao(2,grid)">
              <mat-icon fontSet="fas" fontIcon="fa-exclamation-circle"></mat-icon>
              <span>Anulação </span>
            </button> -->

            <!-- <button mat-menu-item color="primary" [disabled]="!parent.habilitarSubstituicao" (click)="abrirTabAcoes(2)">
              <mat-icon fontSet="fas" fontIcon="fa-refresh"></mat-icon>
              <span>Substituição </span>
            </button>

            <button mat-menu-item color="primary" [disabled]="!parent.habilitarComplementar" (click)="abrirTabAcoes(3)">
              <mat-icon fontSet="fas" fontIcon="fa-repeat"></mat-icon>
              <span>Complementar </span>
            </button>

            <button mat-menu-item color="primary" [disabled]="!parent.habilitarCancelamento" (click)="abrirTabAcoes(4)">
              <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
              <span>Cancelamento </span>
            </button>

            <button mat-menu-item color="primary" [disabled]="!parent.habilitarCartaCorrecao"
              (click)="abrirTabAcoes(5)">
              <mat-icon fontSet="fas" fontIcon="fa-file-text-o"></mat-icon>
              <span>Carta de Correção </span>
            </button>

            <mat-divider></mat-divider>
            <button mat-menu-item color="primary" (click)="irPaginaLogsEnviosCte()">
              <mat-icon fontSet="fas" fontIcon="fa-bars"></mat-icon>
              <span> Log de Envios CT-e </span>
            </button> -->
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="filialEmissaoDescricao">
        <th mat-header-cell *matHeaderCellDef>Filial</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.filialEmissaoDescricao }}
        </td>
      </ng-container>

      <ng-container matColumnDef="numCTE">
        <th mat-header-cell *matHeaderCellDef>Nr CT-e</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.numCTE}}
        </td>
      </ng-container>

      <ng-container matColumnDef="produto">
        <th mat-header-cell *matHeaderCellDef>Produto</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.produtoDesc}}
        </td>
      </ng-container>


      <ng-container matColumnDef="chaveCTE">
        <th mat-header-cell *matHeaderCellDef>Chave CT-e</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.chaveCTE}}
        </td>
      </ng-container>

      <ng-container matColumnDef="dtEmissao">
        <th mat-header-cell *matHeaderCellDef>Data Emissão</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.dtEmissao | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="qtdeNRT">
        <th mat-header-cell *matHeaderCellDef>Qt. NRTs</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.qtdeNRT }}
        </td>
      </ng-container>

      <ng-container matColumnDef="qtdeNF">
        <th mat-header-cell *matHeaderCellDef>Qt. NFs</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.qtdeNF }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tomador">
        <th mat-header-cell *matHeaderCellDef>Tomador</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.tomador }}
        </td>
      </ng-container>
      <ng-container matColumnDef="pid">
        <th mat-header-cell *matHeaderCellDef>PID</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.pid }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cepDestino">
        <th mat-header-cell *matHeaderCellDef>CEP Destino</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.cepDestino }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lote">
        <th mat-header-cell *matHeaderCellDef>Lote</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.lote }}
        </td>
      </ng-container>
      <ng-container matColumnDef="peso">
        <th mat-header-cell *matHeaderCellDef>Peso</th>
        <td mat-cell *matCellDef="let grid">
          <span class="showLink" (click)="parent.visualizarPeso(grid)">{{ grid.peso }} </span>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="tipoCteId">
                <th mat-header-cell *matHeaderCellDef>Tp Cte</th>
                <td mat-cell *matCellDef="let grid">
                    {{ grid.tipoCteId }}
                </td>
            </ng-container> -->
      <ng-container matColumnDef="tipoCteDescricao">
        <th mat-header-cell *matHeaderCellDef>Tp Cte</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.tipoCteDescricao }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="tipoFaturamentoDescricao">
                <th mat-header-cell *matHeaderCellDef>tipoFaturamentoDescricao</th>
                <td mat-cell *matCellDef="let grid">
                    {{ grid.tipoFaturamentoDescricao }}
                </td>
            </ng-container> -->
      <!-- <ng-container matColumnDef="tipoProcessamentoId">
                <th mat-header-cell *matHeaderCellDef>tipoProcessamentoId</th>
                <td mat-cell *matCellDef="let grid">
                    {{ grid.tipoProcessamentoId }}
                </td>
            </ng-container> -->
      <ng-container matColumnDef="tipoProcessamentoDescricao">
        <th mat-header-cell *matHeaderCellDef>Tp Proc</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.tipoProcessamentoDescricao }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="tipoStatusCancelamentoId">
                <th mat-header-cell *matHeaderCellDef>tipoStatusCancelamentoId</th>
                <td mat-cell *matCellDef="let grid">
                    {{ grid.tipoStatusCancelamentoId }}
                </td>
            </ng-container> -->
      <ng-container matColumnDef="tipoStatusCancelamentoDescricao">
        <th mat-header-cell *matHeaderCellDef>Stat. Canc.</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.tipoStatusCancelamentoDescricao }}
        </td>
      </ng-container>
      <ng-container matColumnDef="flagCteAgrupado">
        <th mat-header-cell *matHeaderCellDef>Cte Agrup</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.flagCteAgrupado?'Sim':'Não' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="valorFrete">
        <th mat-header-cell *matHeaderCellDef>V. Frete</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.valorFrete | currency: "BRL" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="adValorem">
        <th mat-header-cell *matHeaderCellDef>V. AdVal</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.adValorem | currency: "BRL"}}
        </td>
      </ng-container>
      <ng-container matColumnDef="gris">
        <th mat-header-cell *matHeaderCellDef>Gris</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.gris }}
        </td>
      </ng-container>
      <ng-container matColumnDef="imposto">
        <th mat-header-cell *matHeaderCellDef>Imp</th>
        <td mat-cell *matCellDef="let grid">
          {{ arredondar(grid.imposto) | currency: "BRL" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="totalFrete">
        <th mat-header-cell *matHeaderCellDef>T. Frete</th>
        <td mat-cell *matCellDef="let grid">
          {{ arredondar(grid.totalFrete) | currency: "BRL" }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef>statusId</th>
                <td mat-cell *matCellDef="let grid">
                    {{ grid.statusId }}
                </td>
            </ng-container> -->
      <ng-container matColumnDef="statusDescricao">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.statusDescricao }}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<div [hidden]="isLoading|| !parent.exibirGrid || grid?.data?.length === 0" style="height: 55px">
  <app-paginacao [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
    (page)="parent.onPageChange($event)" [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
  <section class='FlexContainer'>
    <div class="FlexContainer100 p-2 float-right">
      <div class="align-footer-right float-right">
        <button class="float-right" mat-stroked-button type="button" (click)="download()"
          [disabled]="isLoadingDownload">
          <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
            <mat-spinner diameter="20" color="dark"></mat-spinner>
            &nbsp; Baixando
          </span>
          <span *ngIf="!isLoadingDownload">
            <i class="fas fa-file-excel"></i> Download Excel
          </span>
        </button>
      </div>
    </div>
  </section>
</div>
<div *ngIf="!isLoading && grid?.data?.length === 0" class="d-flex justify-content-center align-items-center"
  style="height: 100px">Nenhum resultado encontrado!</div>